/**
 * MergedProductsModals - Bündelt alle modalen Dialoge der MergedProductsPage
 * Plan 012: QuickView + Generate + FileSort
 */

import { ProductDetailModal, ProductGenerateImageDialog } from '@/components/v2/products'
import { QuickImageSortPanel } from './QuickImageSortPanel'
import type { ProductWithReadiness } from '@/types/products'
import type { Product } from '@/types/products'

interface MergedProductsModalsProps {
  fileDropUpload: {
    productId: string | null
    productName: string
    uploadedImages: unknown[]
    uploading: boolean
  }
  quickViewProduct: ProductWithReadiness | null
  setQuickViewProduct: (p: ProductWithReadiness | null) => void
  generateProduct: ProductWithReadiness | null
  setGenerateProduct: (p: ProductWithReadiness | null) => void
  onCloseSortPanel: () => void
  onNavigate: (path: string) => void
}

export function MergedProductsModals({
  fileDropUpload, quickViewProduct, setQuickViewProduct,
  generateProduct, setGenerateProduct, onCloseSortPanel, onNavigate,
}: MergedProductsModalsProps) {
  return (
    <>
      {fileDropUpload.productId && (
        <QuickImageSortPanel
          open
          onClose={onCloseSortPanel}
          productId={fileDropUpload.productId}
          productName={fileDropUpload.productName}
          uploadedImages={fileDropUpload.uploadedImages as never}
          uploading={fileDropUpload.uploading}
        />
      )}
      <ProductDetailModal
        show={!!quickViewProduct}
        product={quickViewProduct as Product | null}
        onClose={() => setQuickViewProduct(null)}
      />
      <ProductGenerateImageDialog
        show={!!generateProduct}
        product={generateProduct as Product | null}
        onClose={() => setGenerateProduct(null)}
        onOpenProductModal={(p, tab) =>
          onNavigate(`/v2/products/${p.id}?tab=${tab === 'ai-references' ? 'assets' : tab || 'overview'}`)
        }
      />
    </>
  )
}
